// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductNavigation_wrapper__OPHLs","links":"ProductNavigation_links__oCnDU","active":"ProductNavigation_active__x1r-6","count":"ProductNavigation_count__EN1js"};